import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=c9687dec&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=c9687dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9687dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9687dec')) {
      api.createRecord('c9687dec', component.options)
    } else {
      api.reload('c9687dec', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=c9687dec&scoped=true&", function () {
      api.rerender('c9687dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/blindDetail/widget.vue"
export default component.exports